module.exports = __webpack_public_path__ + "img/Cat.a06ede53.png";